import { useCADQuery } from '@/services/queries/cads'

export const useCadVersionId = () => {
  const { data: cadData } = useCADQuery()
  return cadData?.version?.id
}
